import { getAuthHeaders } from "../../auth/services/getAuthHeaders";

export async function createMeeting(
  translatorServiceUrl: string,
  sourceLang: string,
  targetLang: string,
  mode: "traductor" | "minuta" = "traductor",
  folderId?: number | string | null
): Promise<string | null> {
  try {
    const authHeaders = await getAuthHeaders();
    const titleStr = `Sesión ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
    
    const bodyPayload: Record<string, any> = {
      title: titleStr,
      source_lang: sourceLang,
      target_lang: targetLang,
      mode,
    };

    if (folderId !== undefined && folderId !== null && folderId !== "root") {
      bodyPayload.folder_id = folderId;
    }

    const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
    const res = await fetch(`${cleanedUrl}/meeting`, {
      method: "POST",
      headers: { ...authHeaders, "Content-Type": "application/json" },
      body: JSON.stringify(bodyPayload),
    });
    
    if (res.ok) {
      const data = await res.json();
      return data.meeting_id;
    }
  } catch (err) {
    console.warn("Failed to create meeting", err);
  }
  return null;
}
